import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './HeroSection.css';
import { supabase } from '../lib/supabase';
import { getYoutubeUrl, setYoutubeUrl } from '../utils/settings';

function HeroSection() {
  const [inputUrl, setInputUrl] = useState('');
  const [iframeUrl, setIframeUrl] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const init = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user?.email === 'calicorone@gmail.com') setIsAdmin(true);
      const savedUrl = await getYoutubeUrl();
      setInputUrl(savedUrl);
      updateIframeUrl(savedUrl);
    };
    init();
  }, []);

  const updateIframeUrl = (url) => {
    const match = url.match(/(?:youtu\.be\/|v=)([\w-]+)/);
    if (match && match[1]) {
      const id = match[1];
      setIframeUrl(`https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}`);
    } else {
      setIframeUrl('');
    }
  };

  const handleUrlChange = async (e) => {
    const url = e.target.value;
    setInputUrl(url);
    updateIframeUrl(url);
    await setYoutubeUrl(url);
  };

  return (
    <section className="hero-section">
      <div className="hero-inner">
        {/* 매거진 마스트헤드 */}
        <div className="hero-masthead">
          <span className="hero-issue">Vol. 01</span>
          <span className="hero-issue-sep">·</span>
          <span className="hero-issue">2026. 05</span>
          <span className="hero-issue-sep">·</span>
          <span className="hero-issue">{t('hero.issue')}</span>
        </div>
        <div className="hero-green-rule" />

        {/* 3단 컬럼 */}
        <div className="hero-columns">

          {/* 왼쪽 패널 */}
          <div className="hero-side-panel hero-side-left">
            <span className="hero-side-kanji">心</span>
            <div className="hero-side-labels">
              <span>Kokoro</span>
              <span>Archive</span>
              <span>2026</span>
            </div>
          </div>

          {/* 중앙 본문 */}
          <div className="hero-container">
          <div className="hero-text-content">
            <p className="hero-eyebrow">{t('hero.eyebrow')}</p>
            <h1 className="hero-headline">
              {t('hero.line1')}<br />
              {t('hero.line2')}<br />
              <span className="hero-accent">{t('hero.line3')}</span>
            </h1>

            <div className="hero-meta">
              <div className="kokoro-stack">
                <span className="kokoro-line">KOKORO</span>
                <span className="kokoro-line koi">KOIRO</span>
                <span className="kokoro-line">IRO</span>
              </div>
              <div className="hero-tagline-block">
                <p className="kokoro-subtitle">KOKORO + IRO = KOIRO</p>
                <p className="kokoro-tagline">{t('hero.tagline')}</p>
              </div>
            </div>

            <div className="scroll-indicator">
              <span className="scroll-dot" />
              <span className="scroll-text">Scroll to read</span>
            </div>
          </div>

          <div className="hero-media-content">
            {iframeUrl && (
              <div className="youtube-embed-wrapper">
                <div className="youtube-embed">
                  <iframe
                    src={iframeUrl}
                    title="YouTube player"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  />
                </div>
              </div>
            )}
            {isAdmin && (
              <div className="admin-control-wrapper">
                {showInput && (
                  <div className="iframe-input">
                    <input
                      type="text"
                      value={inputUrl}
                      onChange={handleUrlChange}
                      placeholder="YouTube URL..."
                    />
                  </div>
                )}
                <button className="admin-toggle-btn" onClick={() => setShowInput(!showInput)}>
                  {showInput ? 'Close Settings' : 'YouTube Settings'}
                </button>
              </div>
            )}
          </div>
        </div>


          {/* 오른쪽 패널 */}
          <div className="hero-side-panel hero-side-right">
            <span className="hero-side-kanji">色</span>
            <div className="hero-side-labels">
              <span>Iro</span>
              <span>Journey</span>
              <span>Vol.01</span>
            </div>
          </div>

        </div>{/* hero-columns end */}

        {/* 하단 그린 룰 + 이탤릭 스크립트 */}
        <div className="hero-green-rule" />
        <div className="hero-script-bottom">
          <span className="hero-script-italic">{t('hero.tagline')}</span>
          <span className="hero-script-kanji">心 · 色</span>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
